module.exports = __webpack_public_path__ + "img/sales-gpt-logo.a3d7bd0.svg";